import React from 'react';
import { Mail, Linkedin } from 'lucide-react';

const leaders = [
  {
    name: "Joe O'Daniel",
    title: "President & CEO",
    image: "https://i.ibb.co/ZRL544dV/Screenshot-2025-01-29-at-7-53-26-PM.png",
    email: "joe@ucx.co",
    linkedin: "https://www.linkedin.com/in/joseph-o-daniel-03618a1/",
    bio: "Joseph O'Daniel is an expert in network technology, security, and virtualization. He has a long and stellar career in technology, beginning with serving four years in the US Army, stationed in Germany. Following that service, Joe owned or was CTO of several businesses, all related to computer hardware or software. For 10 years, he was also Director of Technology in a Dallas area school district. Joe's passion of focusing on each customer's unique needs drives the Unified ConneXions team to focus on innovative and long-term problem solving and provide the exemplary service needed in today's fast paced world."
  },
  {
    name: "Chris Cunningham",
    title: "Senior Vice President & CFO",
    image: "https://i.ibb.co/sd7SW1zG/Screenshot-2025-01-29-at-7-53-36-PM.png",
    email: "chris@ucx.co",
    linkedin: "https://www.linkedin.com/in/chris-cunningham-b59b471b/",
    bio: "Chris Cunningham provides broad financial leadership at Unified ConneXions, with responsibility for the organization's accounting, treasury, risk control, business planning and analysis, tax, legal, and investor relations. In addition to his proven ability in facilitation, problem-solving, crisis management and conflict resolution, Chris' experience includes aligning corporate financial initiatives to achieve company objectives and leading organizations through aggressive growth and change. Previously, Chris has held senior financial management positions at HVE ConneXions, Inc. He began his career as the Director of Information Technology at a leading academic institution in Dallas. Chris is a member of the North Texas CFO Association. He earned his Bachelor of Science degree from Howard Payne University and MBA in business administration with a concentration in management and information systems from Dallas Baptist University."
  },
  {
    name: "Jon Linsenbardt",
    title: "Sr. Director of Managed Service",
    image: "https://i.ibb.co/nqQNL4Jt/Screenshot-2025-01-29-at-7-53-43-PM.png",
    email: "jon@ucx.co",
    linkedin: "https://www.linkedin.com/in/jon-linsenbardt-64a1b949/",
    bio: "Jon Linsenbardt oversees all corporate and education client monitoring solutions for Unified ConneXions. Through his previous experience in designing and implementing desktop virtualization environments as well as server virtualization environments for multiple clients, Jon offers exceptional expertise in troubleshooting and diagnosing across all customer systems, regardless of size or configuration. He also is an expert in Microsoft Services, including Server, Active Directory, Exchange, and SharePoint."
  },
  {
    name: "Mark Dickson",
    title: "Director of Systems Engineering",
    image: "https://i.ibb.co/BHxPqHfz/Screenshot-2025-01-29-at-7-53-48-PM.png",
    email: "mark@ucx.co",
    linkedin: "https://www.linkedin.com/in/mark-dickson-25311569/",
    bio: "Mark Dickson is one of Unified ConneXions' leading subject matter experts in Microsoft Enterprise and Productivity Solutions. Mark has spent over 15 years in the information technology field, and since joining Unified ConneXions in 2010, has delivered a broad range of solutions to customers in enterprise integration, business intelligence, and cloud services. Prior to his work at UCX, Mark held various technical and management positions in education and government institutions in north Texas."
  }
];

export default function Leadership() {
  return (
    <div className="pt-16">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
              Meet Our Leadership Team
            </h1>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              Our experienced leadership team brings decades of expertise in technology, business operations, and customer service to drive innovation and excellence in everything we do.
            </p>
          </div>
        </div>
      </div>

      {/* Leadership Grid */}
      <div className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            {leaders.map((leader) => (
              <div 
                key={leader.name}
                className="bg-white rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 overflow-hidden"
              >
                <div className="flex flex-col md:flex-row">
                  {/* Image Section */}
                  <div className="w-full md:w-1/4">
                    <div className="aspect-[3/4]">
                      <img
                        src={leader.image}
                        alt={leader.name}
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                  </div>

                  {/* Content Section */}
                  <div className="w-full md:w-3/4 p-6">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                      <div>
                        <h2 className="text-2xl font-bold text-gray-900 mb-1">
                          {leader.name}
                        </h2>
                        <p className="text-sm text-blue-600 font-medium">
                          {leader.title}
                        </p>
                      </div>
                      
                      <div className="flex gap-2 mt-3 md:mt-0">
                        <a
                          href={`mailto:${leader.email}`}
                          className="bg-red-600 text-white px-3 py-1.5 rounded hover:bg-red-700 transition-colors flex items-center text-sm"
                        >
                          <Mail className="h-3.5 w-3.5 mr-1.5" />
                          Email
                        </a>
                        <a
                          href={leader.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bg-blue-600 text-white px-3 py-1.5 rounded hover:bg-blue-700 transition-colors flex items-center text-sm"
                        >
                          <Linkedin className="h-3.5 w-3.5 mr-1.5" />
                          LinkedIn
                        </a>
                      </div>
                    </div>

                    <p className="text-gray-600 text-sm leading-relaxed">
                      {leader.bio}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}